import CartTotal from "components/Cart/CartTotal"
import ProductTable from "components/Product/ProductTable"
import { observer } from "mobx-react"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Button, Message,Table,Icon } from "semantic-ui-react"
import shop from "shop/shop"
import track from "shop/track"
import cmsStore from "stores/cmsStore.js"
import "style/CheckoutPage.scss"
import HeaderCheckout from "pages/checkout/HeaderCheckout"
import queryString from "qs"
import CartExport from "components/Cart/CartExport"
import Price from "components/Price/Price"
import CostCentres from "../../../../components/CostCentres/CostCentres";

@observer
export default class CheckoutPage extends Component {
  
  state = {
    products: getProducts(),
    frachtkosten: true,
    productsTemp: [],
    loadingCart: false
  }
  
  componentDidMount() {

    shop.cart.hooks.changed.add( this.updateCart )
    shop.cart.hydrate()
    track.checkout( { step: 1, products: shop.cart.products } )
    shop.cart.update()
    
  }
  
  handleChange = ({ product }) => {
    shop.cart.add(product);
  }
  
  updateCart = () => {
    let products = getProducts()
    this.setState( { products } )
    this.forceUpdate() 
  }
  
  componentWillUnmount() {
    this.setState({ productsTemp: shop.cart.products, loadingCart: false });
    shop.cart.hooks.changed.remove(this.updateCart);
  }
  
  render() {
    const { referer = "/", ...query } = queryString.parse( location.search, { ignoreQueryPrefix: true } )
    let { products, frachtkosten, loadingCart } = this.state; // include loadingCart in destructuring
    const { loading } = shop.cart;
    const { checkoutType } = this.props.match.params;
    const isRequest = !!checkoutType;
    

    if (loadingCart) {
      return <div>Loading...</div>;
    }
    //console.log("frachtkosten",frachtkosten)
    // MINDERMENGENZUSCHLAG UNTER 50 EUR
    const MIN_ORDER = shop.config.MIN_ORDER_PENALTY_VALUE
    //console.log("PROCUTDS EMPTY?",products)
    products = getProducts()
    const showPenaltyNotice = shop.cart.sum < MIN_ORDER
    shop.cart.hooks.changed.add( this.updateCart )
    //console.log( "shop.cart PRE", shop.cart, shop.cart.data.sum )
    shop.cart.loadCart
    //console.log( "shop.cart POST", shop.cart, shop.cart.data.sum )
    return (
      <div className=" ">
        <HeaderCheckout activeStep={0} isRequest={isRequest} referer={referer}/>
        
        {/*<section className="container pb4">
          <CostCentres />
        </section>*/}
  
        <section className="container">
          <ProductTable cart={shop.cart} onChange={this.handleChange} products={products}/>
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <div className="cf pt3 pb3">
            <div className="fr">
              <CartTotal sum={shop.cart.data.sum} size={shop.cart.size}/>
            </div>
          </div>}
          {/*showPenaltyNotice && <Message>
            <div>{translate( "MIN_ORDER_VALUE_NOTICE", { value: `${shop.config.MIN_ORDER_PENALTY_VALUE}` } )}</div>
      </Message>*/}
      						{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && shop.cart.sum <= shop.config.MIN_ORDER_VALUE &&
						<div className="cf pb2">
							<Message negative className="">
								<div className="total ">
									<div className="ph3">
										<Icon name="info" />{translate( "minimum order value not reached" )}
										<span className="pull-right">
                    						<Price>{shop.config.MIN_ORDER_VALUE}</Price>
								     </span>
									</div>
								</div>
								
							</Message>
						</div>
						}

          {cmsStore.pluginData.export && <div className="pv3">
            <CartExport/>
          </div>}
        </section>
        
        <section className="pa2 mb4 ">
          <div className="container">
            <div className="flex flex-row justify-end">
              
              <Link className={"mr3"} to={referer}>
                <Button>
                  <i className="icon-angle-left"/>
                  {translate( "Zurück" )}
                </Button>
              </Link>
              
              {shop.session && shop.session.shopuser && 
              !shop.session.shopuser.guest && <Link to={{
                pathname: `/checkout/delivery`,
                search  : this.props.location.search
              }}>
                <Button
                  loading={loading}
                  onClick={() => {}}
                  primary>
                  {translate( "Weiter" )}
                  <i className="icon-angle-right"/>
                </Button>
              </Link>}

              {!shop.session.handId && shop.session && shop.session.shopuser && shop.session.shopuser.guest && shop.session.shopuser.guest == true && <Link to={{
                pathname: `${this.props.location.pathname}customer`,
                search  : this.props.location.search
              }}>
                <Button
                  loading={loading}
                  onClick={() => {}}
                  primary>
                  {translate( "Weiter" )}
                  <i className="icon-angle-right"/>
                </Button>
              </Link>}
             
            </div>
          
          </div>
        </section>
      
      
      </div>
    )
  }
}

const getProducts = () => shop.cart.map( ( product ) => product)



// WEBPACK FOOTER //
// ./src/theme/braunco/pages/checkout/CheckoutPageCoupon.js